export default __webpack_public_path__ + "static/media/67t.98c8546d.jpg";